<template>
  <VCol
    class="ml-md-auto px-0 order-md-2 kanban-search"
  >
    <VTextField
      v-model="localValue"
      @keyup.native="handleKeyup"
      :label="$t('search')"
      append-icon="mdi-magnify"
      hide-details
      outlined
      dense
      autocomplete="off"
      class="mb-4 mb-sm-0"
    />
  </VCol>
</template>

<script>
import {
  ref,
  watch,
  onUnmounted,
} from '@vue/composition-api';

export default {
  name: 'VacancyCandidatesKanbanSearch',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const localValue = ref(props.value || '');
    let searchTimeout = null;

    watch(
      () => props.value,
      (newVal) => {
        if (newVal !== localValue.value) {
          localValue.value = newVal || '';
        }
      },
    );

    function emitSearch() {
      emit('input', localValue.value || '');
    }

    function handleKeyup() {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
        searchTimeout = null;
      }
      searchTimeout = setTimeout(() => {
        emitSearch();
        searchTimeout = null;
      }, 200);
    }

    onUnmounted(() => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
        searchTimeout = null;
      }
    });

    return {
      localValue,
      handleKeyup,
    };
  },
};
</script>

<style lang="scss" scoped>
.kanban-search {
  padding: 24px 0;
  @media screen and (max-width: 1263px) {
    padding: 0 0 24px 0;
  }
  @media screen and (max-width: 768px) {
    padding: 12px 0 24px 0;
  }
}
</style>

<i18n locale="en" lang="yaml">
search: Search
</i18n>

<i18n locale="ru" lang="yaml">
search: Поиск
</i18n>
